module.exports = __webpack_public_path__ + "img/__icon_WALKINGFLOOR .0d025f4d.svg";